// @ts-nocheck
import React, { useEffect } from 'react';
import { signoutRedirectCallback } from '../../services/userService';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../hooks';
import { userSignedOut } from '../../reducers/authReducer';

function SignoutOidc() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    async function signoutAsync() {
      await signoutRedirectCallback();
      dispatch(userSignedOut()).then(() => {
        navigate('/');
      });
    }
    signoutAsync();
  }, [dispatch, navigate]);

  return <div>{t('Redirecting...')}</div>;
}

export default SignoutOidc;
